export interface Review {
  id: string;
  title: string;
  author: string;
  authorRole: string;
  date: string;
  rating: number;
  tags: string[];
  summary: string;
  movieId: string;
  content: string[];
  views: number;
}

export const reviewTags = ["搞笑", "感人", "家庭", "冒险", "成长", "视觉"];

export const reviews: Review[] = [
  {
    id: "review-01",
    title: "《神偷奶爸 4》：笑到最后，还是一家人",
    author: "光影小站",
    authorRole: "资深影评人",
    date: "2024-07-15",
    rating: 8,
    tags: ["搞笑", "家庭"],
    summary: "系列走到第四部，套路依旧，但小黄人的喜剧魔法和「家」的内核，依然能让全家人在影院里笑作一团。",
    movieId: "despicable-me-4",
    content: [
      "作为一部拍到第四部的合家欢动画，《神偷奶爸 4》要回答的问题其实很朴素：当观众早已熟悉格鲁一家和小黄人的所有梗，这个系列还能带来什么？",
      "答案是——它并不打算颠覆自己。影片聪明地延续了系列的舒适区：格鲁的奶爸日常、升级版小黄人的爆笑桥段、以及一条足够简单的正邪对立主线。它知道观众想要什么，并且毫不吝啬地给足。",
      "真正让这部电影立住的，是「家」这个内核。无论格鲁的身份如何变化，从神偷到特工，让他始终站稳脚跟的，从来都是家人。小格鲁的加入，让这种家庭温情有了新的表达出口，也让成年观众会心一笑。",
      "当然，影片并非没有短板。反派的动机略显单薄，中段节奏偶有拖沓。但当你带着孩子走进影院，这些都不重要——重要的是，散场时他们笑得很开心。",
    ],
    views: 8200,
  },
  {
    id: "review-02",
    title: "《小黄人大眼萌：神偷奶爸前传》——每个人心里都住着一个少年",
    author: "动画观察室",
    authorRole: "动画研究者",
    date: "2022-07-20",
    rating: 9,
    tags: ["搞笑", "成长", "冒险"],
    summary: "这一部把镜头交还给少年的格鲁，用怀旧的七十年代质感和纯粹的追梦故事，讲出了系列最动人的一次成长。",
    movieId: "rise-of-gru",
    content: [
      "如果说前作是在讲「坏人如何变好」，那么这一部则回到了原点，讲述「一个想变坏的孩子如何长大」。",
      "少年格鲁的设定极为讨喜。他世故、精明，又带着孩子气的执着，一心要加入偶像的反派团体。观众明知他走在「错误」的路上，却很难不为这份笨拙的认真动容。",
      "影片最出彩的地方，是它对七十年代美学的高度还原。从服装、街区到配乐，每一帧都散发着温暖的怀旧气息。动作场面也比系列以往更加大胆，尤其是格鲁习武段落，流畅得令人惊喜。",
      "当格鲁最终与周师父相遇，影片悄悄点出了系列的核心命题：真正的强大不在于「坏」，而在于是否愿意守护重要的人。这份成长，让整部电影有了超越搞笑的分量。",
    ],
    views: 7600,
  },
  {
    id: "review-03",
    title: "《小黄人大眼萌》：当配角拥有了自己的宇宙",
    author: "银幕漫谈",
    authorRole: "独立撰稿人",
    date: "2015-07-25",
    rating: 8,
    tags: ["搞笑", "视觉"],
    summary: "一部由配角担纲的衍生电影，靠着极高的视觉辨识度和密集的笑点，证明了小黄人完全有能力撑起一整个银幕。",
    movieId: "minions-2015",
    content: [
      "把小黄人从《神偷奶爸》里单独拉出来拍一部电影，说实话是有风险的。毕竟它们台词不多，性格也不复杂。但这部电影用事实证明，喜剧的张力从来不只靠台词。",
      "影片的结构很像一段轻松的公路片：从远古到六十年代，小黄人一路寻找最坏的主人。这种时间跨度带来了极大的想象力空间，也让笑点得以不断刷新。",
      "视觉上，这一部的完成度极高。六十年代伦敦的复古质感、斯嘉丽一家的夸张造型，都让画面充满记忆点。小黄人们的肢体喜剧在大银幕上被放大到极致，几乎每一分钟都有让人发笑的瞬间。",
      "它或许不是系列里最有深度的作品，但绝对是最欢乐的一部。如果你只想收获两个小时的好心情，它不会让你失望。",
    ],
    views: 6800,
  },
  {
    id: "review-04",
    title: "《神偷奶爸》：坏蛋的外壳下，藏着一个关于家的故事",
    author: "深夜放映厅",
    authorRole: "影评专栏作者",
    date: "2011-01-08",
    rating: 9,
    tags: ["感人", "家庭"],
    summary: "作为系列开山之作，《神偷奶爸》用最朴素的温情打动人心——再坏的坏蛋，也扛不住三个孩子的一句「晚安」。",
    movieId: "despicable-me",
    content: [
      "这是整个系列梦开始的地方，也是最能让人眼眶一热的一部。",
      "格鲁的设定非常有意思：他是「世界第一神偷」，却把自己的生活过成了一出孤独的独角戏。直到三个小女孩闯入他的世界，那层坚硬的外壳才开始一点一点剥落。",
      "影片最妙的处理，是把「偷月亮」这个天大计划，放在「当爸爸」这件小事面前当成陪衬。当格鲁在剧场里冲上台去保护孩子们的那一刻，观众忽然明白，这部电影真正想讲的从来不是盗窃，而是爱与陪伴。",
      "小黄人作为配角的点睛之笔，也让影片的喜剧节奏恰到好处。十几年过去，这份「坏蛋也能有温柔」的浪漫，依然动人。",
    ],
    views: 6100,
  },
  {
    id: "review-05",
    title: "从配色到节奏：小黄人为什么让人一眼就记住",
    author: "设计看动画",
    authorRole: "视觉设计博主",
    date: "2023-09-12",
    rating: 8,
    tags: ["视觉", "搞笑"],
    summary: "亮黄、护目镜、背带裤——小黄人的角色设计堪称教科书级别。这篇影评从视觉设计角度拆解它们的「记忆点」是如何炼成的。",
    movieId: "minions-2015",
    content: [
      "在所有好莱坞动画角色里，小黄人的辨识度几乎是最高的那一档。这种成功并非偶然，而是一整套视觉语言精心设计的结果。",
      "首先是颜色。明亮饱和的黄色在一片色彩复杂的画面中永远是最抢眼的存在，这让小黄人无论出现在哪里都能立刻抓住观众的视线。",
      "其次是造型。圆润的胶囊形身体、厚重的护目镜、标志性的背带裤，三样元素组合在一起，既拟人又抽象，既可爱又有辨识度，几乎无法被混淆。",
      "最后是节奏。小黄人的动作夸张而不失协调，它们的群戏编排像一段精心设计的舞蹈。正是这种「视觉上的快乐」，让观众在还没听懂它们在说什么之前，就已经笑了出来。",
    ],
    views: 5200,
  },
  {
    id: "review-06",
    title: "《神偷奶爸 2》：当坏蛋爸爸学会了爱",
    author: "观影手记",
    authorRole: "家庭电影推荐官",
    date: "2013-08-05",
    rating: 8,
    tags: ["感人", "家庭", "搞笑"],
    summary: "这一部把格鲁的「奶爸身份」放在中心，用一场保护世界的冒险，讲了一个父亲如何守护女儿的故事。",
    movieId: "despicable-me-2",
    content: [
      "经历了第一部的心软之后，《神偷奶爸 2》里的格鲁已经彻底变成了一个围着女儿们转的好爸爸。",
      "影片巧妙地把「保护世界」和「保护家人」两条线交织在一起。当危险最终降临到女儿们身上，格鲁的愤怒与勇气显得格外真实——这一刻，他不是特工，只是一个父亲。",
      "露西的加入为系列带来了新鲜的化学反应。两人从针锋相对到彼此依靠，感情线自然又不抢戏，恰到好处地丰富了格鲁的人物弧光。",
      "小黄人依旧是全片最大的笑点来源，它们一边搞事一边救场，把紧张的情节调节得张弛有度。作为一部家庭电影，它足够温暖，也足够欢乐。",
    ],
    views: 4700,
  },
  {
    id: "review-07",
    title: "短片里的小黄人：四分钟如何讲好一个故事",
    author: "短片研究所",
    authorRole: "动画短片策展人",
    date: "2020-04-18",
    rating: 7,
    tags: ["搞笑", "视觉"],
    summary: "从小黄人系列短片说起，聊聊在极短时长里，创作者是如何用肢体喜剧和视觉叙事完成一次完整表达的。",
    movieId: "minion-short-banana",
    content: [
      "小黄人系列的一大宝藏，是那些几分钟的衍生短片。它们时长极短，却往往笑点密集、结构完整。",
      "短片的秘诀在于「简化」。当没有足够的时长铺陈剧情，创作者便把所有精力集中在单个强烈的冲突上，比如一根香蕉的争夺，一次失败的露营。",
      "小黄人「无需台词」的特性，恰好适配这种叙事方式。它们靠表情和动作推动故事，让短片跨越语言障碍，在任何国家的观众那里都能准确传达笑点。",
      "四分钟讲好一个故事，听起来简单，做起来极难。小黄人短片用极高的完成度证明，短，也可以是一种有力的表达。",
    ],
    views: 3900,
  },
];

export const getReviewById = (id: string): Review | undefined =>
  reviews.find((r) => r.id === id);